module.exports = __webpack_public_path__ + "static/media/allocate.27225b10.svg";